import React from 'react'

import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import CircularProgress from '@material-ui/core/CircularProgress'
import grey from '@material-ui/core/colors/grey'
import red from '@material-ui/core/colors/red'
import orange from '@material-ui/core/colors/orange'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormGroup from '@material-ui/core/FormGroup'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import DescriptionIcon from '@material-ui/icons/Description'
import LinearProgress from '@material-ui/core/LinearProgress'
import Box from '@material-ui/core/Box'
import Tooltip from '@material-ui/core/Tooltip'
import Alert from '@material-ui/lab/Alert'

import Cookie from 'js-cookie'
import moment from 'moment'

import OrderProcessor from '../../sales/components/order-processor/OrderProcessor'
import { copyObject } from '../../tools/utils'
import PickListProcessor from '../containers/pick-list-processor'
import { getPath } from '../../oakra/components/base-app'
import { post } from '../../tools/request'

const styles = (theme) => ({
    pickPackBatchInfo: {
        marginTop: 20,
    },
    header: {
        display: 'flex',
        padding: '15px 30px 0px 30px',
    },
    lowerHeader: {
        display: 'flex',
        borderBottom: '1px solid lightgray',
        color: grey[600],
        size: '0.875rem',
        padding: '0px 30px 15px 30px',
    },
    mainSection: {
        display: 'flex',
        padding: '15px 30px',
    },
    infoSection: {
        paddingRight: 30,
        paddingTop: 20,
        paddingBottom: 20,
        width: 250,
    },
    infoItem: {
        marginBottom: 30,
    },
    infoItemLabel: {
        fontWeight: 500,
        marginBottom: 5,
    },
    infoSubSection: {
        display: 'flex',
    },
    infoSubSectionItem: {
        marginRight: 40,
        '&:last-child': {
            marginRight: 0,
        },
    },
    statusIndicator: {
        display: 'flex',
    },
    statusIndicatorDot: {
        marginRight: 10,
    },
    printSection: {
        display: 'flex',
        flexDirection: 'column',
        borderLeft: '1px solid lightgray',
        paddingLeft: 30,
        paddingTop: 20,
        paddingBottom: 20,
    },
    createDocumentsActions: {
        display: 'flex',
        alignItems: 'center',
    },
    documentOptionsFormControl: {},
    documentOptionsGroup: {
        flexDirection: 'row',
        width: 300,
    },
    documentOptionLabel: {
        fontSize: '0.9rem',
    },
    createDocumentButton: {
        width: 300,
        marginLeft: 10,
    },
    labelsContainer: {
        marginTop: 10,
        marginBottom: 10,
    },
    labels: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 10,
        marginBottom: 15,
    },
    labelActions: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    shippingLabelWithItemListGroup: {
        flexDirection: 'row',
        width: 300,
        fontSize: '0.9rem',
    },
    shippingLabelWithItemListLabel: {
        fontSize: '0.9rem',
    },
    createShippingLabelsButton: {
        width: 300,
        marginLeft: 10,
    },
    documentLinks: {
        marginTop: 10,
        display: 'flex',
        flexDirection: 'row',
    },
    documentsLoading: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 10,
    },
    creatingDocumentsText: {
        marginLeft: 10,
    },
    creatingDocumentsErrorText: {
        color: theme.palette.error.main,
    },
    creatingPickPackBatchMessage: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    creatingPickPackBatchText: {
        marginTop: 10,
        color: grey[700],
    },
    creatingShippingLabelsText: {
        marginTop: 10,
        marginBottom: 20,
        color: grey[700],
        lineHeight: 1.3,
        textAlign: 'center',
    },
    pickPackBatchButton: {
        marginBottom: 20,
        cursor: 'pointer',
        width: 300,
    },
    documentButton: {
        marginRight: 20,
        color: grey[600],
        textTransform: 'none',
    },
    footer: {
        display: 'flex',
        flexDirection: 'row',
        borderTop: '1px solid lightgray',
        padding: '15px 30px',
    },
    actionButton: {
        color: 'white',
        marginRight: 20,
    },
    errorSection: {
        marginTop: 20,
    },
    errorList: {
        paddingInlineStart: 0,
        listStyle: 'none',
        color: red[400],
        marginTop: 0,
        '& li': {
            margin: '8px 0',
            wordBreak: 'break-word',
        },
        '& li a': {
            color: red[400],
        },
    },
    canceledList: {
        paddingInlineStart: 0,
        listStyle: 'none',
        marginTop: 0,
        '& li': {
            margin: '8px 0',
            wordBreak: 'break-word',
        },
        '& li a': {
            color: grey[900],
        },
    },
    orderWithErrorsMessage: {
        color: grey[900],
        marginBottom: 12,
    },
})

const statusIndicatorColors = {
    confirming: grey[300],
    ready_to_pick: grey[500],
    in_progress: orange[300],
    completed: '#41C49C',
    error: red[400],
}

const PICK_PACK_BATCH_POLLING_TIMEOUT = 18000000
const PICK_PACK_BATCH_POLLING_INTERVAL = 2000
const DOCUMENTS_POLLING_TIMEOUT = 120000
const DOCUMENTS_POLLING_INTERVAL = 1000

function LinearProgressWithLabel({ value, ...props }) {
    return (
        <Box display="flex" alignItems="center">
            <Box width="100%" mr={1}>
                <LinearProgress color="secondary" variant="determinate" {...props} value={value} />
            </Box>
            <Box minWidth={16}>
                <Typography variant="body2" color="textSecondary">{`${value}%`}</Typography>
            </Box>
        </Box>
    )
}

class PickPackBatch extends React.PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            pickPackBatch: null,
            pickPackBatchLoading: true,
            allShippingLabelsAvailable: false,
            pickListChecked: false,
            packListChecked: false,
            coverSheetChecked: false,
            taxInvoiceChecked: false,
            creatingShippingLabels: false,
            creatingDocuments: false,
            createShippingLabelsError: '',
            createDocumentsError: '',
            displayConfirmCompletion: false,
            displayPickListProcessor: false,
            displayOrderProcessor: false,
            showShippingLabelNotAvailableMessage: false,
            shippingLabelNotAvailableMessage: '',
            includeItemListChecked: true,
            verticalOnlyChecked: false,
        }
        this.shippingLabelsAvailablePollInterval = null
        this.shippingLabelsPollInterval = null
        this.pickPackBatchPollInterval = null
        this.documentsPollInterval = null

        this.fetchPickPackBatch = this.fetchPickPackBatch.bind(this)
        this.checkShippingLabelsAvailable = this.checkShippingLabelsAvailable.bind(this)
        this.beginPollingShippingLabelsAvailable =
            this.beginPollingShippingLabelsAvailable.bind(this)
        this.handleCheckDocumentOption = this.handleCheckDocumentOption.bind(this)
        this.handleCreateDocuments = this.handleCreateDocuments.bind(this)
        this.handleCreateLabels = this.handleCreateLabels.bind(this)
        this.beginPollingDocuments = this.beginPollingDocuments.bind(this)
        this.beginPollingShippingLabels = this.beginPollingShippingLabels.bind(this)
        this.handleAllOrdersProcessed = this.handleAllOrdersProcessed.bind(this)
        this.handleConfirmation = this.handleConfirmation.bind(this)
        this.updatePickPackBatch = this.updatePickPackBatch.bind(this)
        this.handleOpenPickListProcessor = this.handleOpenPickListProcessor.bind(this)
        this.handleClosePickListProcessor = this.handleClosePickListProcessor.bind(this)
        this.handleOpenOrderProcessor = this.handleOpenOrderProcessor.bind(this)
        this.handleCloseOrderProcessor = this.handleCloseOrderProcessor.bind(this)

        moment.locale(props.language)
    }

    componentDidMount() {
        this.fetchPickPackBatch(() => {
            if (this.state.pickPackBatch.status === 'confirming') {
                this.beginPollingPickPackBatch()
            } else {
                this.beginPollingShippingLabelsAvailable()
            }
        })
    }

    componentWillUnmount() {
        if (this.pickPackBatchPollInterval) {
            clearInterval(this.pickPackBatchPollInterval)
            this.pickPackBatchPollInterval = null
        }
        if (this.shippingLabelsAvailablePollInterval) {
            clearInterval(this.shippingLabelsAvailablePollInterval)
            this.shippingLabelsAvailablePollInterval = null
        }
        if (this.shippingLabelsPollInterval) {
            clearInterval(this.shippingLabelsPollInterval)
            this.shippingLabelsPollInterval = null
        }
        if (this.documentsPollInterval) {
            clearInterval(this.documentsPollInterval)
            this.documentsPollInterval = null
        }
    }

    fetchPickPackBatch(callback) {
        const { pick_pack_batch_id } = this.props.match.params
        const { pickPackBatchAPIURL } = this.props

        fetch(pickPackBatchAPIURL.replace('pick_pack_batch_pk', pick_pack_batch_id))
            .then((response) => response.json())
            .then((pickPackBatch) => {
                this.setState({ pickPackBatch }, callback)
            })
    }

    checkShippingLabelsAvailable(callback) {
        const { pick_pack_batch_id } = this.props.match.params
        const { pickPackBatchAllLabelsAvailableAPIURL } = this.props

        fetch(
            pickPackBatchAllLabelsAvailableAPIURL.replace('pick_pack_batch_pk', pick_pack_batch_id)
        )
            .then((response) => response.json())
            .then((result) => {
                callback(result)
            })
    }

    beginPollingShippingLabelsAvailable() {
        if (this.shippingLabelsAvailablePollInterval) {
            clearInterval(this.shippingLabelsAvailablePollInterval)
        }

        this.shippingLabelsAvailablePollInterval = setInterval(() => {
            this.checkShippingLabelsAvailable((result) => {
                if (result.all_shipping_labels_available) {
                    clearInterval(this.shippingLabelsAvailablePollInterval)
                    this.setState({ allShippingLabelsAvailable: true })
                } else {
                    if (result.reason) {
                        clearInterval(this.shippingLabelsAvailablePollInterval)
                        this.setState({
                            allShippingLabelsAvailable: false,
                            showShippingLabelNotAvailableMessage: true,
                            shippingLabelNotAvailableMessage: result.reason,
                        })
                    }
                }
            })
        }, 3000)
    }

    handleCheckDocumentOption(e) {
        const option = e.target.value

        this.setState({ [option]: !this.state[option] })
    }

    beginPollingShippingLabels() {
        if (this.shippingLabelsPollInterval) {
            clearInterval(this.shippingLabelsPollInterval)
        }

        let startTime = new Date().getTime()

        this.shippingLabelsPollInterval = setInterval(() => {
            if (new Date().getTime() - startTime > DOCUMENTS_POLLING_TIMEOUT) {
                clearInterval(this.shippingLabelsPollInterval)
                this.shippingLabelsPollInterval = null

                this.setState({
                    creatingShippingLabels: false,
                    createShippingLabelsError: gettext(
                        'Generating shipping labels took long than expected. Please refresh the page and try again.'
                    ),
                })
                return
            }
            this.fetchPickPackBatch(() => {
                const shippingLabelsReadyStatus = this.state.pickPackBatch.documents
                    .filter(
                        (doc) => doc.document_type === 'shipping_labels' && doc.status !== 'failed'
                    )
                    .map((doc) => doc.is_ready)
                const allShippingLabelsReady = shippingLabelsReadyStatus.every((status) => status)

                const failedFileNames = this.state.pickPackBatch.documents
                    .filter((doc) => doc.status === 'failed')
                    .map((doc) => doc.name)

                if (allShippingLabelsReady) {
                    clearInterval(this.shippingLabelsPollInterval)
                    this.shippingLabelsPollInterval = null

                    let createShippingLabelsError = ''
                    if (failedFileNames.length > 0) {
                        createShippingLabelsError = interpolate(
                            gettext('Failed to generate files: %s. Please try again later.'),
                            [failedFileNames]
                        )
                    }
                    this.setState({
                        creatingShippingLabels: false,
                        createShippingLabelsError: createShippingLabelsError,
                    })
                }
            })
        }, DOCUMENTS_POLLING_INTERVAL)
    }

    beginPollingDocuments() {
        if (this.documentsPollInterval) {
            clearInterval(this.documentsPollInterval)
        }
        let startTime = new Date().getTime()
        this.documentsPollInterval = setInterval(() => {
            if (new Date().getTime() - startTime > DOCUMENTS_POLLING_TIMEOUT) {
                clearInterval(this.shippingLabelsPollInterval)
                this.shippingLabelsPollInterval = null

                this.setState({
                    creatingDocuments: false,
                    createDocumentsError: gettext(
                        'Documents generation timed out. Please refresh the page and try again later. If this issue persists, please contact us.'
                    ),
                })
                return
            }
            this.fetchPickPackBatch(() => {
                const documentsReadyStatus = this.state.pickPackBatch.documents
                    .filter((doc) => doc.document_type === 'documents' && doc.status !== 'failed')
                    .map((doc) => doc.is_ready)
                const allDocumentsReady = documentsReadyStatus.every((status) => status)

                const failedFileNames = this.state.pickPackBatch.documents
                    .filter((doc) => doc.status === 'failed')
                    .map((doc) => doc.name)

                if (allDocumentsReady) {
                    clearInterval(this.documentsPollInterval)
                    this.documentsPollInterval = null

                    let createDocumentsError = ''
                    if (failedFileNames.length > 0) {
                        createDocumentsError = interpolate(
                            gettext(
                                'Failed to generate files: %s. Please try again later. If this issue persists, please contact us.'
                            ),
                            [failedFileNames]
                        )
                    }

                    this.setState({
                        creatingDocuments: false,
                        createDocumentsError: createDocumentsError,
                    })
                }
            })
        }, DOCUMENTS_POLLING_INTERVAL)
    }

    handleCreateDocuments() {
        const { createPickPackBatchDocumentsAPIURL } = this.props

        const pickPackBatch = copyObject(this.state.pickPackBatch)

        let maxID
        if (pickPackBatch.documents.length > 0) {
            const docIDs = pickPackBatch.documents.map((doc) => doc.id)
            maxID = Math.max(docIDs)
        } else {
            maxID = 0
        }

        pickPackBatch.documents.push({ id: maxID + 1, is_ready: false })

        const creatingDocumentsState = {
            creatingDocuments: true,
            pickListChecked: false,
            packListChecked: false,
            coverSheetChecked: false,
            taxInvoiceChecked: false,
            createDocumentsError: '',
        }

        const data = {
            pick_list: this.state.pickListChecked,
            pack_list: this.state.packListChecked,
            cover_sheet: this.state.coverSheetChecked,
            tax_invoice: this.state.taxInvoiceChecked,
        }

        this.setState(creatingDocumentsState, () => {
            let url = createPickPackBatchDocumentsAPIURL.replace(
                'pick_pack_batch_pk',
                this.state.pickPackBatch.id
            )

            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'X-CSRFToken': Cookie.get('csrftoken'),
                },
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then(() => {
                    this.beginPollingDocuments()
                })
        })
    }

    handleCreateLabels() {
        const { createPickPackBatchLabelsAPIURL } = this.props

        const pickPackBatch = copyObject(this.state.pickPackBatch)

        let maxID
        if (pickPackBatch.documents.length > 0) {
            const docIDs = pickPackBatch.documents.map((doc) => doc.id)
            maxID = Math.max(docIDs)
        } else {
            maxID = 0
        }

        pickPackBatch.documents.push({ id: maxID + 1, is_ready: false })

        const creatingShippingLabelsState = {
            creatingShippingLabels: true,
            createShippingLabelsError: '',
        }

        const data = {
            with_item_list: this.state.includeItemListChecked,
            vertical_format: this.state.verticalOnlyChecked,
        }

        this.setState(creatingShippingLabelsState, () => {
            let url = createPickPackBatchLabelsAPIURL.replace(
                'pick_pack_batch_pk',
                this.state.pickPackBatch.id
            )

            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'X-CSRFToken': Cookie.get('csrftoken'),
                },
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then(() => {
                    this.beginPollingShippingLabels()
                })
        })
    }

    updatePickPackBatch(data) {
        const { pickPackBatchAPIURL } = this.props

        fetch(pickPackBatchAPIURL.replace('pick_pack_batch_pk', this.state.pickPackBatch.id), {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'X-CSRFToken': Cookie.get('csrftoken'),
            },
            body: JSON.stringify(data),
        })
            .then((response) => response.json())
            .then((pickPackBatch) => {
                this.setState({ pickPackBatch })
            })
    }

    handleAllOrdersProcessed() {
        this.setState({ displayConfirmCompletion: true })
    }

    handleConfirmation(confirm) {
        return () => {
            if (confirm) {
                this.updatePickPackBatch({ status: 'completed' })
            }

            this.setState({ displayConfirmCompletion: false })
        }
    }

    handleOpenPickListProcessor() {
        const newState = { displayPickListProcessor: true }

        if (this.state.pickPackBatch.status === 'created') {
            const pickPackBatch = copyObject(this.state.pickPackBatch)
            pickPackBatch.status = 'in_progress'
            newState['pickPackBatch'] = pickPackBatch
            this.updatePickPackBatch({ status: 'in_progress' })
        }

        this.setState(newState)
    }

    handleClosePickListProcessor() {
        this.setState({ displayPickListProcessor: false })
    }

    handleOpenOrderProcessor() {
        const newState = { displayOrderProcessor: true }

        if (this.state.pickPackBatch.status === 'created') {
            const pickPackBatch = copyObject(this.state.pickPackBatch)
            pickPackBatch.status = 'in_progress'
            newState['pickPackBatch'] = pickPackBatch
            this.updatePickPackBatch({ status: 'in_progress' })
        }

        this.setState(newState)
    }

    handleCloseOrderProcessor() {
        const state = {
            displayOrderProcessor: false,
        }

        this.setState(state)
    }

    handleRetryBatch = () => {
        const { pickPackBatchRetryAPIURL } = this.props
        post(
            pickPackBatchRetryAPIURL.replace('pick_pack_batch_pk', this.state.pickPackBatch.id)
        ).then(({ ok }) => {
            if (ok) {
                this.beginPollingPickPackBatch()
            }
        })
    }

    beginPollingPickPackBatch = () => {
        if (this.pickPackBatchPollInterval) {
            clearInterval(this.pickPackBatchPollInterval)
        }

        let startTime = new Date().getTime()

        this.pickPackBatchPollInterval = setInterval(() => {
            if (new Date().getTime() - startTime > PICK_PACK_BATCH_POLLING_TIMEOUT) {
                clearInterval(this.pickPackBatchPollInterval)
                this.pickPackBatchPollInterval = null
                return
            }
            this.fetchPickPackBatch(() => {
                const status = this.state.pickPackBatch.status

                if (status !== 'confirming') {
                    clearInterval(this.pickPackBatchPollInterval)
                    this.pickPackBatchPollInterval = null

                    // start polling shipping labels available
                    this.beginPollingShippingLabelsAvailable()
                }
            })
        }, PICK_PACK_BATCH_POLLING_INTERVAL)
    }

    render() {
        const { classes } = this.props
        const pickPackBatch = this.state.pickPackBatch
        const isPickPackBatchReady = pickPackBatch && pickPackBatch.status !== 'confirming'
        const pickPackBatchInfo = pickPackBatch
            ? `${pickPackBatch.location.name} - ${moment(pickPackBatch.date_created).format(
                  'D MMM HH:mm'
              )}`
            : ''

        const showRetryButton = pickPackBatch?.status === 'error'

        return (
            <Paper className={classes.pickPackBatchInfo}>
                <div className={classes.header}>
                    <Typography>{`${gettext('Pick/pack batch')} ${
                        this.props.match.params?.pick_pack_batch_id
                    }`}</Typography>
                </div>
                <div className={classes.lowerHeader}>{pickPackBatchInfo}</div>
                <div className={classes.mainSection}>
                    <div className={classes.infoSection}>
                        <div className={classes.infoItem}>
                            <Typography variant="body2" className={classes.infoItemLabel}>
                                {gettext('Status')}
                            </Typography>
                            {pickPackBatch && (
                                <div>
                                    <div className={classes.statusIndicator}>
                                        <div
                                            className={classes.statusIndicatorDot}
                                            style={{
                                                backgroundColor:
                                                    statusIndicatorColors[pickPackBatch.status],
                                                width: 16,
                                                height: 16,
                                                borderRadius: 8,
                                            }}
                                        />
                                        <Typography className={classes.tableText} variant="body2">
                                            {pickPackBatch.status_display_name}
                                        </Typography>
                                    </div>
                                    {pickPackBatch.status === 'confirming' && (
                                        <LinearProgressWithLabel value={pickPackBatch.progress} />
                                    )}
                                </div>
                            )}
                        </div>

                        <div className={classes.infoItem}>
                            <Typography variant="body2" className={classes.infoItemLabel}>
                                {gettext('Date created')}
                            </Typography>
                            {pickPackBatch && (
                                <Typography variant="body2">
                                    {moment(pickPackBatch.date_created).format('lll')}
                                </Typography>
                            )}
                        </div>

                        <div className={classes.infoSubSection}>
                            <div className={classes.infoSubSectionItem}>
                                <Typography variant="body2" className={classes.infoItemLabel}>
                                    {gettext('Orders')}
                                </Typography>
                                {pickPackBatch && (
                                    <Typography variant="body2">
                                        {pickPackBatch.num_fulfillments}
                                    </Typography>
                                )}
                            </div>

                            <div className={classes.infoSubSectionItem}>
                                <Typography variant="body2" className={classes.infoItemLabel}>
                                    {gettext('Total items')}
                                </Typography>
                                {pickPackBatch && (
                                    <Typography variant="body2">
                                        {pickPackBatch.num_items}
                                    </Typography>
                                )}
                            </div>
                        </div>

                        {pickPackBatch?.error_fulfillments?.length > 0 && (
                            <div className={classes.errorSection}>
                                <Typography variant="body2" className={classes.infoItemLabel}>
                                    {gettext('Orders with errors')}
                                </Typography>
                                <ul className={classes.errorList}>
                                    {pickPackBatch?.error_fulfillments.map(
                                        (errorFulfilmentInfo) => (
                                            <li key={errorFulfilmentInfo.fulfillment_pk}>
                                                <Tooltip
                                                    title={errorFulfilmentInfo.error_message}
                                                    placement="right"
                                                >
                                                    <a
                                                        href={getPath('sale').replace(
                                                            'sale_id',
                                                            errorFulfilmentInfo.sale_pk
                                                        )}
                                                        target="_blank"
                                                    >
                                                        {errorFulfilmentInfo.sale_id}
                                                    </a>
                                                </Tooltip>
                                            </li>
                                        )
                                    )}
                                </ul>
                                {showRetryButton && (
                                    <Button
                                        color="secondary"
                                        variant="outlined"
                                        onClick={this.handleRetryBatch}
                                    >
                                        {gettext('Retry')}
                                    </Button>
                                )}
                            </div>
                        )}

                        {pickPackBatch?.canceled_fulfillments?.length > 0 && (
                            <div className={classes.errorSection}>
                                <Typography variant="body2" className={classes.infoItemLabel}>
                                    {gettext('Canceled orders')}
                                </Typography>
                                <ul className={classes.canceledList}>
                                    {pickPackBatch?.canceled_fulfillments.map(
                                        (canceledFulfillmentInfo) => (
                                            <li key={canceledFulfillmentInfo.fulfillment_pk}>
                                                <a
                                                    href={getPath('sale').replace(
                                                        'sale_id',
                                                        canceledFulfillmentInfo.sale_pk
                                                    )}
                                                    target="_blank"
                                                >
                                                    {canceledFulfillmentInfo.sale_id}
                                                </a>
                                            </li>
                                        )
                                    )}
                                </ul>
                            </div>
                        )}

                        {pickPackBatch?.in_cancel_fulfillments?.length > 0 && (
                            <div className={classes.errorSection}>
                                <Typography variant="body2" className={classes.infoItemLabel}>
                                    {gettext('Cancel requested')}
                                </Typography>
                                <ul className={classes.canceledList}>
                                    {pickPackBatch?.in_cancel_fulfillments.map(
                                        (fulfillmentInfo) => (
                                            <li key={fulfillmentInfo.fulfillment_pk}>
                                                <a
                                                    href={getPath('sale').replace(
                                                        'sale_id',
                                                        fulfillmentInfo.sale_pk
                                                    )}
                                                    target="_blank"
                                                >
                                                    {fulfillmentInfo.sale_id}
                                                </a>
                                            </li>
                                        )
                                    )}
                                </ul>
                            </div>
                        )}
                    </div>

                    <div className={classes.printSection}>
                        {pickPackBatch?.status === 'error' && (
                            <Alert
                                variant="outlined"
                                severity="info"
                                className={classes.orderWithErrorsMessage}
                            >
                                {gettext(
                                    'Some orders have errors, but you can print labels and documents for those that were successful'
                                )}
                            </Alert>
                        )}
                        <Typography variant="subtitle2">{gettext('Shipping labels')}</Typography>
                        <div className={classes.labels}>
                            <div className={classes.labelActions}>
                                <FormControl component="fieldset">
                                    <FormGroup className={classes.shippingLabelWithItemListGroup}>
                                        <FormControlLabel
                                            classes={{
                                                label: classes.shippingLabelWithItemListLabel,
                                            }}
                                            control={
                                                <Checkbox
                                                    checked={this.state.includeItemListChecked}
                                                    onChange={this.handleCheckDocumentOption}
                                                    value="includeItemListChecked"
                                                    disabled={this.state.creatingShippingLabels}
                                                />
                                            }
                                            label={gettext('Include Item list')}
                                        />
                                        <FormControlLabel
                                            classes={{
                                                label: classes.shippingLabelWithItemListLabel,
                                            }}
                                            control={
                                                <Checkbox
                                                    checked={this.state.verticalOnlyChecked}
                                                    onChange={this.handleCheckDocumentOption}
                                                    value="verticalOnlyChecked"
                                                    disabled={this.state.creatingShippingLabels}
                                                />
                                            }
                                            label={gettext('Vertical only')}
                                        />
                                    </FormGroup>
                                </FormControl>
                                <Button
                                    className={classes.createDocumentButton}
                                    variant="outlined"
                                    color="primary"
                                    onClick={() => {
                                        this.fetchPickPackBatch(this.handleCreateLabels)
                                    }}
                                    disabled={
                                        !isPickPackBatchReady ||
                                        !this.state.allShippingLabelsAvailable
                                    }
                                >
                                    {gettext('Create shipping labels')}
                                </Button>
                            </div>

                            {isPickPackBatchReady &&
                                !this.state.allShippingLabelsAvailable &&
                                !this.state.shippingLabelNotAvailableMessage && (
                                    <div className={classes.documentsLoading}>
                                        <CircularProgress
                                            className={classes.currentPickPackBatchProgress}
                                            color="secondary"
                                            size={15}
                                        />
                                        <Typography
                                            variant="body2"
                                            className={classes.creatingDocumentsText}
                                        >
                                            {gettext(
                                                'Checking if shipping labels are available. If this does not change, please check back a little later.'
                                            )}
                                        </Typography>
                                    </div>
                                )}

                            {this.state.creatingShippingLabels && (
                                <div className={classes.documentsLoading}>
                                    <CircularProgress
                                        className={classes.currentPickPackBatchProgress}
                                        color="secondary"
                                        size={15}
                                    />
                                    <Typography
                                        variant="body2"
                                        className={classes.creatingDocumentsText}
                                    >
                                        {gettext(
                                            'Please wait, it may take several minutes to generate your labels'
                                        )}
                                    </Typography>
                                </div>
                            )}

                            {this.state.showShippingLabelNotAvailableMessage && (
                                <div className={classes.documentsLoading}>
                                    <Typography
                                        variant="body2"
                                        className={classes.creatingDocumentsText}
                                    >
                                        {this.state.shippingLabelNotAvailableMessage}
                                    </Typography>
                                </div>
                            )}

                            {this.state.allShippingLabelsAvailable &&
                                !!this.state.createShippingLabelsError && (
                                    <Typography
                                        variant="body2"
                                        className={classes.creatingDocumentsErrorText}
                                    >
                                        {this.state.createShippingLabelsError}
                                    </Typography>
                                )}

                            <div className={classes.documentLinks}>
                                {pickPackBatch &&
                                    pickPackBatch.documents &&
                                    pickPackBatch.documents
                                        .filter(
                                            (doc) =>
                                                doc.is_ready &&
                                                doc.document_type === 'shipping_labels'
                                        )
                                        .map((doc) => (
                                            <Button
                                                className={classes.documentButton}
                                                target="_blank"
                                                href={doc.url}
                                                key={doc.id}
                                                startIcon={<DescriptionIcon />}
                                            >
                                                {doc.name}
                                            </Button>
                                        ))}
                            </div>
                        </div>

                        <Typography variant="subtitle2">{gettext('Documents')}</Typography>
                        <div className={classes.createDocumentsActions}>
                            <FormControl
                                component="fieldset"
                                className={classes.documentOptionsFormControl}
                            >
                                <FormGroup className={classes.documentOptionsGroup}>
                                    <FormControlLabel
                                        classes={{ label: classes.documentOptionLabel }}
                                        control={
                                            <Checkbox
                                                checked={this.state.pickListChecked}
                                                onChange={this.handleCheckDocumentOption}
                                                value="pickListChecked"
                                                disabled={this.state.creatingDocuments}
                                            />
                                        }
                                        label={gettext('Pick list')}
                                    />
                                    <FormControlLabel
                                        classes={{ label: classes.documentOptionLabel }}
                                        control={
                                            <Checkbox
                                                checked={this.state.packListChecked}
                                                onChange={this.handleCheckDocumentOption}
                                                value="packListChecked"
                                                disabled={this.state.creatingDocuments}
                                            />
                                        }
                                        label={gettext('Pack list')}
                                    />
                                    <FormControlLabel
                                        classes={{ label: classes.documentOptionLabel }}
                                        control={
                                            <Checkbox
                                                checked={this.state.coverSheetChecked}
                                                onChange={this.handleCheckDocumentOption}
                                                value="coverSheetChecked"
                                                disabled={this.state.creatingDocuments}
                                            />
                                        }
                                        label={gettext('Cover sheet')}
                                    />
                                    <FormControlLabel
                                        classes={{ label: classes.documentOptionLabel }}
                                        control={
                                            <Checkbox
                                                checked={this.state.taxInvoiceChecked}
                                                onChange={this.handleCheckDocumentOption}
                                                value="taxInvoiceChecked"
                                                disabled={this.state.creatingDocuments}
                                            />
                                        }
                                        label={gettext('Tax invoice')}
                                    />
                                </FormGroup>
                            </FormControl>
                            <Button
                                className={classes.createDocumentButton}
                                variant="outlined"
                                color="primary"
                                onClick={() => {
                                    this.fetchPickPackBatch(this.handleCreateDocuments)
                                }}
                                disabled={
                                    !isPickPackBatchReady ||
                                    (!this.state.pickListChecked &&
                                        !this.state.packListChecked &&
                                        !this.state.coverSheetChecked &&
                                        !this.state.taxInvoiceChecked)
                                }
                            >
                                {gettext('Create documents')}
                            </Button>
                        </div>

                        {this.state.creatingDocuments && (
                            <div className={classes.documentsLoading}>
                                <CircularProgress
                                    className={classes.currentPickPackBatchProgress}
                                    color="secondary"
                                    size={15}
                                />
                                <Typography
                                    variant="body2"
                                    className={classes.creatingDocumentsText}
                                >
                                    {gettext(
                                        'Please wait, it may take several minutes to generate this document'
                                    )}
                                </Typography>
                            </div>
                        )}
                        {!!this.state.createDocumentsError && (
                            <Typography
                                variant="body2"
                                className={classes.creatingDocumentsErrorText}
                            >
                                {this.state.createDocumentsError}
                            </Typography>
                        )}

                        <div className={classes.documentLinks}>
                            {pickPackBatch &&
                                pickPackBatch.documents &&
                                pickPackBatch.documents
                                    .filter(
                                        (doc) => doc.is_ready && doc.document_type === 'documents'
                                    )
                                    .map((doc) => (
                                        <Button
                                            className={classes.documentButton}
                                            target="_blank"
                                            href={doc.url}
                                            key={doc.id}
                                            startIcon={<DescriptionIcon />}
                                        >
                                            {doc.name}
                                        </Button>
                                    ))}
                        </div>
                    </div>
                </div>
                <div className={classes.footer}>
                    <Button
                        className={classes.actionButton}
                        color="primary"
                        variant="contained"
                        disabled={!isPickPackBatchReady || pickPackBatch.status === 'completed'}
                        onClick={this.handleAllOrdersProcessed}
                    >
                        {gettext('Confirm all orders processed')}
                    </Button>
                    <Button
                        className={classes.actionButton}
                        color="primary"
                        variant="contained"
                        disabled={!isPickPackBatchReady}
                        onClick={this.handleOpenPickListProcessor}
                    >
                        {gettext('Gather items')}
                    </Button>
                    <Button
                        className={classes.actionButton}
                        color="primary"
                        variant="contained"
                        disabled={!isPickPackBatchReady}
                        onClick={this.handleOpenOrderProcessor}
                    >
                        {gettext('Pack orders')}
                    </Button>

                    {pickPackBatch?.num_items_requiring_serial_number > 0 && (
                        <Typography variant="body2" style={{ paddingTop: 8, color: red[400] }}>
                            {interpolate(
                                gettext('%s items require serial numbers'),
                                [
                                    pickPackBatch.num_items_requiring_serial_number
                                ]
                            )}
                        </Typography>
                    )}
                </div>
                <Dialog className={classes.dialog} open={this.state.displayConfirmCompletion}>
                    <DialogTitle>{gettext('Complete pick pack batch')}</DialogTitle>
                    <DialogContent className={classes.dialogContent}>
                        <Typography variant="body2">
                            {gettext('Have you packed all orders for this pick pack batch?')}
                        </Typography>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <Button color="secondary" onClick={this.handleConfirmation(false)}>
                            {gettext('No')}
                        </Button>
                        <Button color="secondary" onClick={this.handleConfirmation(true)}>
                            {gettext('Yes')}
                        </Button>
                    </DialogActions>
                </Dialog>
                <PickListProcessor
                    open={this.state.displayPickListProcessor}
                    pickPackBatch={pickPackBatch}
                    handleClose={this.handleClosePickListProcessor}
                />
                <OrderProcessor
                    open={this.state.displayOrderProcessor}
                    pickPackBatch={pickPackBatch}
                    handleClose={this.handleCloseOrderProcessor}
                />
            </Paper>
        )
    }
}

export default withStyles(styles)(PickPackBatch)
